import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import * as _ from 'lodash';
import { FundraiserListService } from 'app/manage-p2p/services/fundraiser-list/fundraiser-list.service';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone:true,
  selector: 'app-p2p-champion-and-donor-search',
  templateUrl: './p2p-champion-and-donor-search.component.html',
  styleUrl: './p2p-champion-and-donor-search.component.scss',
  imports:[FormsModule,CommonModule,ReactiveFormsModule]
})
export class P2pChampionAndDonorSearchComponent implements OnInit{
  destroyRef = inject(DestroyRef)
  @Output() itemSelected = new EventEmitter<any>();

  public searchedItems = [];
  public itemSearch: UntypedFormControl = new UntypedFormControl('', []);

  public allTransactions = [];
  public selectedItem: any = null;
  
  constructor(
    public fundraiserListService: FundraiserListService
  ) {}

  ngOnInit() {
    const donors = this.fundraiserListService.uniqueDonors();

    this.searchedItems = donors;

    this.itemSearch.valueChanges.pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(search => {
      this.searchedItems = donors.filter((item)=>
        item.name.toLowerCase().includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase()) 
      );
    })
  }

  seeItemDetails(item) {
    this.selectedItem = _.cloneDeep(item);

    this.itemSelected.emit(this.selectedItem);
  }

  resetSearch() {
    this.itemSearch.setValue('');
  }
}
